export const ResourceAvailabilityValues = {
  OK: 'OK',
  LOW: 'LOW',
  NONE: 'NONE',
} as const;

export type KnownResourceAvailability = (typeof ResourceAvailabilityValues)[keyof typeof ResourceAvailabilityValues];

// eslint-disable-next-line sonarjs/no-useless-intersection
export type ResourceAvailability = KnownResourceAvailability | (string & {});
